<template>
  <div>
    <div class="base-mobile-card-container mb-4">


      <vs-row v-for="(row, index) in data" :key="index" class="base-mobile-card">
        <vs-col>

          <!-- Header -->
          <div class="base-mobile-card-header">
            <span class="base-mobile-card-title">{{ row[titleKey] }}</span>
          </div>

          <!-- Body -->
          <div class="base-mobile-card-body">
            <div v-for="col in bodyColumns" :key="col.key" class="card-field">
              <span class="card-label">{{ $t(col.label) | capitalize }}:</span>
              <span class="card-value">
                <slot :name="`col-${col.key}`" :row="row">
                  {{ row[col.key] }}
                </slot>
              </span>
            </div>
          </div>

          <!-- Footer / Actions -->
          <div v-if="actions && actions.length" class="base-mobile-card-actions" :class="actionClass || null"
            :style="actionStyle || null">
              <div v-for="(action, actionIndex) in actions" :key="'action-' + actionIndex">
                  <base-action-icon
                    v-if="(!action.hideIf || !action.hideIf(row)) && hasPermission(action.permissions)"
                    :tooltip="action.tooltip"
                    :icon="action.icon"
                    :class="action.customClass || null"
                    :style="action.customStyle || null"
                    @click="() => { if (typeof action.onClick === 'function') action.onClick(row) }"
                  />
                </div>
          </div>
        </vs-col>
      </vs-row>
    </div>
    <!-- 🔑 Trigger de infinite scroll -->
    <div v-if="data.length" class="module-card-trigger" v-observe-visibility="visibilityChanged"></div>
  </div>
</template>

<script>
import BaseActionIcon from '@/views/app/components/actions/BaseActionIcon.vue';

export default {
  name: "BaseCard",
  components: { BaseActionIcon },
  props: {
    columns: { type: Array, required: true },
    data: { type: Array, required: true },
    actions: { type: Array, default: () => [] },
    actionClass: { type: String, default: null },
    actionStyle: { type: String, default: null },
    titleKey: { type: String, required: true },
    infiniteHandler: { type: Function, required: false } // 👈 nueva prop
  },
  computed: {
    bodyColumns() {
      return this.columns.filter(col => col.key !== this.titleKey);
    }
  },
  methods: {
    visibilityChanged(isVisible) {
      if (isVisible) {
        this.$emit('loadMore')
      }
    }
  }
};
</script>

<style>
.base-mobile-card-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  /* 👈 separación entre cards */
}

.base-mobile-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}

/* Header */
.base-mobile-card-header {
  background: #BC1300;
  padding: 14px;
  display: flex;
  align-items: center;
}

.base-mobile-card-title {
  font-weight: 600;
  font-size: 1.1rem;
  color: #fff;
  letter-spacing: 0.5px;
}

/* Body */
.base-mobile-card-body {
  padding: 16px;
  font-size: 0.95rem;
  line-height: 1.5;
  color: #333;
}

.card-field {
  margin-bottom: 6px;
}

.card-label {
  font-weight: bold;
  color: #ba1300;
  margin-right: 4px;
}

.card-value {
  color: #333;
}

/* Footer / Actions */
.base-mobile-card-actions {
  display: flex;
  justify-content: flex-end;
  padding: 12px 16px;
  background: #fff;
  gap: 10px;
  border-top: 1px solid #f0f0f0;
}

/* 🔑 Trigger aislado */
.module-card-trigger {
  height: 1px;
  /* apenas visible */
  background: none;
  /* no afecta estilos */
}
</style>